import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      this.element.querySelectorAll("[data-scroll-reveal]").forEach(el => el.classList.add("revealed"))
      return
    }

    this._observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const delay = entry.target.dataset.scrollRevealDelayValue || 0
          setTimeout(() => entry.target.classList.add("revealed"), delay)
          this._observer.unobserve(entry.target)
        }
      })
    }, { threshold: 0.15, rootMargin: "0px 0px -50px 0px" })

    this.element.querySelectorAll("[data-scroll-reveal]").forEach(el => {
      this._observer.observe(el)
    })
  }

  disconnect() {
    if (this._observer) this._observer.disconnect()
  }
}
